import Track from "../components/track/track";

const Trackpage = () => {

    return (
        <div>
            <h1>Track Page</h1>
            <Track></Track>
        </div>
    );
}
export default Trackpage;